import React, { useEffect } from "react";
import UserHeroSection from "components/user/UserHeroSection";
import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import PetsTable from "components/user/pets-table/PetsTable";
import UserAuth from "components/AuthGaurd/UserAuth";

const MyPets = () => {
  return (
    <UserAuth>
      <header>
        <Header />
      </header>

      {/* hero section */}
      <UserHeroSection title="My Pets" btnTitle="Add New Pet">
        <PetsTable />
      </UserHeroSection>

      <footer className="tw-block">
        <Footer />
      </footer>
    </UserAuth>
  );
};

export default MyPets;
